import React, { useContext } from "react";
import {
    GelParagraph,
    GelContainerLite,
    GelLink,
    GelColumnLayout,
    GelScreenDetectorContext,
    GelHeading4
} from '@tal-gel/components';
import { getGelTokens } from '@tal-gel/theming';
import styled from "@emotion/styled";
import { useCookies } from "react-cookie";
import { AdobeAnalytics } from "../../common/analytics/adobe-analytics";
import { AdobeClickType } from "../../constants/constants";
import { useGetHealthAndSupportPageContent } from "../../common/api/graphQLDataFetch";

const HealthConnectorCampaign = () => {
    const { global: { sizeNone, themeColorBackgroundDefault, fontSizeHeadingMedium, sizeBaseX6, fontSizeBodyDefault,
        fontSizeBodySmall, sizeBaseX5, fontSizeHeadingXSmall, themeColorBackgroundInverse, sizeBaseX2 }
    } = getGelTokens();

    const { screen, isLargerThanMdScreen, isXsScreen, isSmScreen } = useContext(GelScreenDetectorContext) as GelScreenDetectorContext;
    const [{ tpid }] = useCookies(["tpid"]);

    const { data } = useGetHealthAndSupportPageContent()

    const ImageContainer = styled.div`
        position: relative;
        text-align: center;
        background-size: cover;
        background-repeat: no-repeat;
        height: 100%;
        min-height: ${() => isXsScreen(screen) | isSmScreen(screen) ? "278px" : "238px"};
        width: 100%;
        background-position: center;
    `;


    const Spacer = styled.div(() => ({
        paddingTop: sizeBaseX6
    }));

    const onLinkClick = (linkText) => {
        AdobeAnalytics.PushClickEvent(tpid, linkText, AdobeClickType.Link)
    }

    return (
        <GelContainerLite id="healthConnectorCampaignContainer" style={{ padding: sizeNone }}>
            <GelColumnLayout verticalGutter={sizeNone} gutter={sizeNone} distribution={isXsScreen(screen) | isSmScreen(screen) ? "1" : "1/2 1/2"}>

                <ImageContainer id="supportService" style={{ backgroundImage: `url(${data?.healthConnectorCampaignImage.url})` }}>
                    <GelLink href={data?.healthConnectorLink} target="_blank"
                        onClick={() => onLinkClick(data?.healthConnectorLinkText)}>
                        <GelContainerLite style={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)", padding: "60px 40px" }}>
                            <GelHeading4 style={{ color: themeColorBackgroundDefault, fontSize: isLargerThanMdScreen(screen) ? fontSizeHeadingMedium : fontSizeHeadingXSmall }}>
                                {data?.healthConnectorCampaignImage.title}
                            </GelHeading4>

                            <GelParagraph style={{ color: themeColorBackgroundDefault, fontSize: isLargerThanMdScreen(screen) ? fontSizeBodyDefault : fontSizeBodySmall }}>
                                {data?.healthConnectorCampaignImage.description}
                            </GelParagraph>
                        </GelContainerLite>
                    </GelLink>
                </ImageContainer>

                <GelContainerLite style={{
                    minHeight: isXsScreen(screen) | isSmScreen(screen) ? "278px" : "238px", backgroundColor: themeColorBackgroundInverse,
                    padding: isLargerThanMdScreen(screen) ? `${sizeBaseX2}% ${sizeBaseX5}px` : `${sizeBaseX2}% ${sizeBaseX5}px`
                }}>
                    <GelParagraph style={{ color: themeColorBackgroundDefault }}>
                        {data?.healthConnectorText}

                        <Spacer />

                        <GelLink style={{ color: themeColorBackgroundDefault }}
                            href={data?.healthConnectorLink}
                            target="_blank"
                            onClick={() => onLinkClick(data?.healthConnectorLinkText)}>
                            {data?.healthConnectorLinkText}
                        </GelLink>
                    </GelParagraph>
                </GelContainerLite>

            </GelColumnLayout>
        </GelContainerLite>
    )
};

export default HealthConnectorCampaign;